// ** Redux & Store & Actions
import { useDispatch } from "react-redux";
import { setGender } from "store/modules/auth";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import loadable from "@loadable/component";

// ** Custom Components
import GenderButton from "../GenderButton";

const StepCoupleGender = loadable(
	() =>
		import(
			"containers/Landing/containers/Register/components/StepCoupleGender"
		),
	{ ssr: false }
);

// ** Styles Import
import { ButtonGroup } from "containers/Landing/components/ButtonGroup";

// #####################################################

const GenderContent = ({
	selectedGender,
	setShowGenderEmptyMessage,
	isModal,
}) => {
	const { t } = useTranslation("common");

	const dispatch = useDispatch();

	const handleSelectGender = (gender) => {
		setShowGenderEmptyMessage(false);
		dispatch(setGender(gender));
	};

	// #####################################################

	return (
		<ButtonGroup>
			<GenderButton
				onClick={() => handleSelectGender("woman")}
				active={selectedGender === "woman"}
				label={t("sexOptions.woman")}
				isModal={isModal}
			>
				{t("sexOptions.woman")}
			</GenderButton>
			<GenderButton
				onClick={() => handleSelectGender("man")}
				active={selectedGender === "man"}
				label={t("sexOptions.man")}
				isModal={isModal}
			>
				{t("sexOptions.man")}
			</GenderButton>
			<GenderButton
				onClick={() => handleSelectGender("couple")}
				active={selectedGender === "couple"}
				label={t("sexOptions.couple")}
				isModal={isModal}
				onTouchStart={() => {
					StepCoupleGender.preload();
				}}
				onMouseOver={() => {
					StepCoupleGender.preload();
				}}
			>
				{t("sexOptions.couple")}
			</GenderButton>
			<GenderButton
				onClick={() => handleSelectGender("transsexual")}
				active={selectedGender === "transsexual"}
				label={t("sexOptions.transsexual")}
				isModal={isModal}
			>
				{t("sexOptions.transsexual")}
			</GenderButton>
		</ButtonGroup>
	);
};

// #####################################################

export default GenderContent;

// #####################################################
